import { htmlToNode } from 'js/utils/Utils'
import { deepMerge } from 'js/utils/Utils'

const defaults = {
  separator: '',
  addClass: '',
  $names: {
    target: '[data-split]',
    parent: '[data-split-parent]',
  },
  attrName: {
    item: 'data-split-item',
    inner: 'data-split-inner',
    clone: 'data-clone',
  },
  className: {
    item: 'split_item',
    inner: 'split_inner',
    clone: 'split_clone',
    blank: '-blank',
  },
  dataNames: {
    // autoAriaLabel: '',
    hasInner: 'splitHasInner',
    isClone: 'splitClone',
  },
  _getTemplate: (_this, index, value, length) => {
    return `<span class="${_this.className.item}" ${_this.attrName.item} style="display: inline-flex; min-width: 0.2em; min-height: 0.2em;">${value}</span>`
  },
  _getTemplateHasInner: (_this, index, value, length) => {
    return `<span class="${_this.className.item}" ${_this.attrName.item} style="display: inline-flex; min-width: 0.2em; min-height: 0.2em;">
                <span class="${_this.className.inner}" ${_this.attrName.inner} style="display: block;">${value}</span>
            </span>`
  },
}

export default class TextSplit {
  constructor(options = {}) {
    this.$contentRoot = document
    this.tag = ''
    this.isTag = false
    this.$targetAll = null

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    if (this._hasTargetLength()) {
      this.$targetAll.forEach(($target) => {
        this._run($target)
      })
    }
  }

  _set$() {
    this.$targetAll = this.$contentRoot.querySelectorAll(this.$names.target)
  }

  _run($target) {
    let fragment = new DocumentFragment(),
      str = this._unEscapeHTML($target.innerHTML),
      split = str.split(this.separator),
      clone = this._isClone($target),
      inner = this._hasInner($target),
      $parent = $target.closest(this.$names.parent)

    if ($parent) {
      const ariaLabel = $parent.getAttribute('aria-label')

      if (!ariaLabel || !ariaLabel.length) {
        $parent.setAttribute('aria-label', str)
      } else {
        $parent.setAttribute('aria-label', ariaLabel + ' ' + str)
      }

      $target.setAttribute('aria-hidden', 'true')
    } else {
      $target.setAttribute('aria-label', str)
    }

    if (/[\t\s]/g.test(split[split.length - 1])) {
      split.pop()
    }

    $target.innerHTML = ''

    split.forEach((value, index) => {
      let $strElement = null
      this._checkString(value)

      if (!this.isTag && this.tag.length === 0) {
        if (inner) {
          $strElement = htmlToNode(this._getTemplateHasInner(this, index, value, split.length))[0]
        } else {
          $strElement = htmlToNode(this._getTemplate(this, index, value, split.length))[0]
        }

        if (clone) {
          // $strElement.classList.add(this.className.clone)
          $strElement.setAttribute(this.attrName.clone, $target.dataset[this.dataNames.isClone] || '')
        }

        if (this._isBlank(value)) {
          $strElement.classList.add(this.className.blank)
        }

        if (!$parent) {
          $strElement.setAttribute('aria-hidden', 'true')
        }

        fragment.appendChild($strElement)
      }
    })

    $target.appendChild(fragment)
  }

  _checkString(value) {
    if (value === '<') {
      this.isTag = true
      this.tag += value
    } else if (value === '>') {
      this.tag += value
      this.isTag = false
    } else if (this.isTag) {
      this.tag += value
    } else {
      this.tag = ''
    }
  }

  _unEscapeHTML(str) {
    return str
      .replace(/(&lt;)/g, '<')
      .replace(/(&gt;)/g, '>')
      .replace(/(&quot;)/g, '"')
      .replace(/(&#39;)/g, "'")
      .replace(/(&amp;)/g, '&')
  }

  _hasTargetLength() {
    return this.$targetAll.length
  }

  _hasInner($target) {
    return $target.dataset[this.dataNames.hasInner] !== undefined
  }

  _isClone($target) {
    return $target.dataset[this.dataNames.isClone] !== undefined
  }

  _isBlank(value) {
    return /[\t\s]/g.test(value)
  }
}